import angular from 'angular';
import { isEmpty } from 'lodash';
import '../../services/subscription';
import '../../services/line';
import '../../services/area';
import '../../services/resource-group';

const module = angular.module('whyline.modals.assign-user', [
  'whyline.components.status',
  'whyline.services.subscription',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.resource-group',
]);

const AssignUserController = (
  $scope,
  $timeout,
  $uibModalInstance,
  SubscriptionService,
  LineService,
  subscription,
  currentPlaceId,
  $translate,
  AreaService,
  ResourceGroupService,
  $state,
) => {
  'ngInject';

  $scope.subscription = SubscriptionService.Copy(subscription);
  $scope.subscriptionUserPreferences = !isEmpty($scope.subscription.userPreferences)
    ? $scope.subscription.userPreferences
    : [];

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };
  $scope.activeLine = $state.params.lineId;

  if ($scope.subscription.queueData.type === 'area') {
    AreaService.GetWithLinesAsPromise($scope.subscription.queueData.queueId).then((data) => {
      LineService.FindByIds(data.lines, { promise: true, force: true }).then((response) => {
        $scope.lines = response;
        ResourceGroupService.GetUsersByLines(data.lines).then((resources) => {
          const keys = Object.keys($scope.lines);
          keys.forEach((id) => {
            const res = resources.find((r) => r.resources[0].resourceId === id);
            $scope.lines[id].users = res.users;
            $scope.lines[id].users.unshift({
              profile: { firstName: $translate.instant('select_user') },
              _id: '',
            });
            $scope.lines[id].selectedUser = $scope.lines[id].users[0];
            if ($scope.subscriptionUserPreferences.length) {
              const preference = $scope.subscriptionUserPreferences.find((up) => up.lineId === id);
              if (preference) {
                const user = $scope.lines[id].users.find((u) => u._id === preference.userId);
                $scope.lines[id].selectedUser = user || $scope.lines[id].users[0];
              }
            }
          });
        });
      });
    });
  } else {
    LineService.GetOneAsPromise($scope.subscription.queueData.queueId).then((data) => {
      $scope.lines = [data];
      ResourceGroupService.GetUsersByLines([data._id]).then((resources) => {
        $scope.lines.forEach((line) => {
          const res = resources.find((r) => r.resources[0].resourceId === line._id);
          $scope.lines[0].users = res.users;
          $scope.lines[0].users.unshift({
            profile: { firstName: $translate.instant('select_user') },
            _id: '',
          });
          $scope.lines[0].selectedUser = $scope.lines[0].users[0];
          if ($scope.subscriptionUserPreferences.length) {
            const preference = $scope.subscriptionUserPreferences.find(
              (up) => up.lineId === $scope.lines[0]._id,
            );
            if (preference) {
              const user = $scope.lines[0].users.find((u) => u._id === preference.userId);
              $scope.lines[0].selectedUser = user || $scope.lines[0].users[0];
            }
          }
        });
      });
    });
  }

  $scope.updatedUser = (line) => {
    const userAlreadyUpdatedIndex = $scope.subscriptionUserPreferences.findIndex(
      (up) => up.lineId === line._id,
    );
    if (userAlreadyUpdatedIndex > -1) {
      $scope.subscriptionUserPreferences[userAlreadyUpdatedIndex] = {
        userId: line.selectedUser._id,
        lineId: line._id,
        called: false
      };
    } else {
      $scope.subscriptionUserPreferences.push({ userId: line.selectedUser._id, lineId: line._id, called: false });
    }
  };

  $scope.save = () => {
    const keys = Object.keys($scope.lines);
    $scope.subscriptionUserPreferences.forEach((preference) => {
      if (!preference.userId) {
        $scope.subscriptionUserPreferences.splice(
          $scope.subscriptionUserPreferences.indexOf(preference),
          1,
        );
      }
    });
    SubscriptionService.UpdateUserPreferences(
      $scope.subscription._id,
      $scope.subscriptionUserPreferences,
      $scope.activeLine,
    ).then(() => {
      $uibModalInstance.close('saved');
    });
  };
};

module.exports = module.controller('AssignUserController', AssignUserController);
